import SelectMultiple from '../select_multiple/select_multiple';
import RadioTemplate from '../radio-buttons/radio_buttons';
import LabeledInput from '../labeled-input/labeled_input';
import SelectBasic from '../select_basic/single_basic';
import HeartRating from '../heart_rating/heart_rating';
import PhoneNumber from '../phoneNumber/phone-number';
import Flutterwave from '../flutterwave/flutterwave';
import Description from '../description/description';
import StarRating from '../star_rating/star_rating';
import FileUpload from '../file_upload/file_upload';
import EmbedField from '../embed-video/embed-field';
import TextInput from '../text-input/text_input';
import NumberInput from '../number-field/number';
import CheckBox from '../checkboxes/checkboxes';
import MediaImage from '../add_Image/add_image';
import ScaleRating from '../scale-field/scale';
import Signature from '../signature/signature';
import DateTime from '../date-time/date-time';
import LongText from '../long-text/long_text';
import SmileyRating from '../smiley/smiley';
import Paystack from '../paystack/paystack';
import Email from '../email-field/email';
import Website from '../website/website';
import Country from '../country/country';
import Stripe from '../stripe/stripe';
import Paypal from '../paypal/paypal';
import LookUp from '../lookup/lookup';

const AllowedFields = {
  email: Email,
  lookup: LookUp,
  stripe: Stripe,
  paypal: Paypal,
  country: Country,
  website: Website,
  paystack: Paystack,
  phone: PhoneNumber,
  datetime: DateTime,
  text_area: LongText,
  checkboxes: CheckBox,
  signature: Signature, // support signature for forms that already contain it
  text_input: TextInput,
  short_text: TextInput,
  media_image: MediaImage,
  embed_field: EmbedField,
  file_upload: FileUpload,
  star_rating: StarRating,
  description: Description,
  flutterwave: Flutterwave,
  select_basic: SelectBasic,
  number_input: NumberInput,
  heart_rating: HeartRating,
  scale_rating: ScaleRating,
  smiley_rating: SmileyRating,
  inline_checkboxes: CheckBox,
  labeled_input: LabeledInput,
  appended_text: LabeledInput,
  prepended_text: LabeledInput,
  radio_buttons: RadioTemplate,
  inline_radios: RadioTemplate,
  select_multiple: SelectMultiple,
};

export default AllowedFields;
